export const safeNumber = (value: string | undefined) => {
  return value && !isNaN(Number(value)) ? Number(value) : undefined;
};
